import type {
  LibraryDifficulty,
  LibraryRightsStatus,
  LibraryStudyType,
} from "@/api/db/schema/library";

export const libraryStudyTypeLabels: Record<LibraryStudyType, string> = {
  original_research: "Özgün araştırma",
  systematic_review: "Sistematik derleme",
  meta_analysis: "Meta-analiz",
  position_stand: "Görüş bildirisi",
  narrative_review: "Anlatısal derleme",
  other: "Diğer",
};

export const libraryDifficultyLabels: Record<LibraryDifficulty, string> = {
  beginner: "Başlangıç",
  intermediate: "Orta",
  advanced: "İleri",
};

export const libraryRightsLabels: Record<LibraryRightsStatus, string> = {
  metadata_only: "Bibliyografik bilgi ve özgün değerlendirme",
  open_access: "Açık erişim",
  licensed_reuse: "Yeniden kullanım izni doğrulandı",
};
